export const TABLET_WIDTH = 720
export const DESKTOP_WIDTH = 1024

export const MAIN_SECTION = {
    BOOK_A_CALL: "book_a_call",
    ABOUT_US_HISTORY: "about_us_history"
}

export const NAVIGATION_LINKS = {
    HOME: "/",
    ABOUT_US: "/about-us",
    PRIVACY_POLICY: "/privacy-policy",
    TEAM_AUGMENTATION: "/services/team-augmentation",
    TRYNOW: "/cases/try-now",
    ORBIT: "/cases/orbit",
    GAMETECH: "/cases/gametech",
    HELLO: "/cases/quarkworks/hello",
    QUARKWORKS: "/cases/quarkworks",
    CRAFT: "/cases/quarkworks/craft",
    PEDNET: "/cases/quarkworks/pednet",
    ERROR: "/error",
    IT_CONSULTING_AND_ADVISORY: "/services/it-consulting-and-advisory",

    DONATE: "/donate",
    FORTUNE_WHEEL:  "/fortune-wheel",
}

export const ANALYTICS_TRACKER_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKER_ID
